// animations.ts
import { trigger, state, style, transition, animate } from '@angular/animations';

export const animations = {
    fadeAnimation: trigger('fadeAnimation', [
        state('in', style({ opacity: 1 })),
        transition(':enter', [
            style({ opacity: 0 }),
            animate(600)
        ]),
        transition(':leave',
            animate(600, style({ opacity: 0 })))
    ])
};
